export default {
  "nav": {
    "home": "Home",
    "menu": "Menu",
    "mobile_app": "Mobile App",
    "contact_us": "Contact Us",
    "sign_in": "Sign In",
    "cart": "Cart",
    "logout": "Logout",
    "profile": "Profile",
    "orders": "Orders",
    "notifications": "Notifications",
    "no_address_found": "No address found"
  },
  "header": {
    "title": "Delicious Food, Delivered Fast",
    "description": "Connect with the best local restaurants and enjoy your favorite cuisines delivered right to your door. DASHBASKET brings you authentic flavors and exceptional service, making every meal special without leaving home.",
    "greeting": "Hi, {{name}}",
    "there": "there"
  },
  "buttons": {
    "add_to_cart": "Add to Cart",
    "remove_from_cart": "Remove from Cart",
    "place_order": "Place Order",
    "proceed_to_checkout": "Proceed to Checkout",
    "continue_shopping": "Continue Shopping",
    "view_cart": "View Cart",
    "update": "Update",
    "save": "Save",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "back": "Back",
    "next": "Next",
    "submit": "Submit",
    "search": "Search",
    "filter": "Filter",
    "apply": "Apply",
    "reset": "Reset",
    "edit": "Edit",
    "delete": "Delete",
    "view": "View"
  },
  "food": {
    "popular_dishes": "Popular Dishes",
    "new_arrivals": "New Arrivals",
    "recommended": "Recommended",
    "vegetarian": "Vegetarian",
    "vegan": "Vegan",
    "gluten_free": "Gluten Free",
    "spicy": "Spicy",
    "price": "Price",
    "ingredients": "Ingredients",
    "nutrition_info": "Nutrition Information",
    "calories": "Calories",
    "add_special_instructions": "Add special instructions",
    "out_of_stock": "Out of Stock",
    "food_item": "Food item",
    "unnamed_item": "Unnamed Item",
    "no_description": "No description available"
  },
  "footer": {
    "about_us": "About Us",
    "privacy_policy": "Privacy Policy",
    "terms_of_service": "Terms of Service",
    "help_center": "Help Center",
    "contact": "Contact",
    "follow_us": "Follow Us",
    "download_app": "Download our app",
    "all_rights_reserved": "All rights reserved",
    "google_play_store": "Google Play Store",
    "apple_app_store": "Apple App Store",
    "links": "Links",
    "services": "Services",
    "apply_as_restaurant": "Apply as Restaurant",
    "apply_as_driver": "Apply as Driver",
    "information": "Information",
    "support": "Support",
    "powered_by": "Powered by"
  },
  "restaurants": {
    "closed": "Closed",
    "search_placeholder": "Search restaurants...",
    "filters": {
      "delivery_fee": "Delivery Fee",
      "all_delivery_fees": "All Delivery Fees",
      "free_delivery": "Free Delivery",
      "under_2000_bif": "Under 2000 BIF",
      "under_3000_bif": "Under 3000 BIF",
      "all_cuisines": "All Cuisines",
      "all_prices": "All Prices",
      "all_ratings": "All Ratings",
      "stars": "stars",
      "under_40_min": "Under 40 min",
      "open_now": "Open",
      "closing_soon": "Closing Soon",
      "no_restaurants_found": "No restaurants found matching your criteria.",
      "clear_all_filters": "Clear all filters",
      "calculating_delivery_fee": "Calculating delivery fee...",
      "delivery_fee_unavailable": "Delivery fee unavailable",
      "no_reviews_yet": "No reviews yet",
      "new": "New",
      "km_away": "Km away"
    }
  },
  "cart": {
    "title": "My Cart",
    "confirm_clear_all": "Are you sure you want to clear all carts?",
    "share_cart_details": "Share cart details",
    "cart_cleared": "Cart cleared successfully",
    "failed_to_clear_cart": "Failed to clear cart",
    "failed_to_share_cart": "Failed to share cart",
    "cart_shared": "Cart shared successfully",
    "no_items": "No items in cart",
    "subtotal": "Subtotal",
    "delivery_fee": "Delivery Fee",
    "total": "Total",
    "clear_cart": "Clear Cart",
    "share_cart": "Share Cart",
    "proceed_to_order": "Proceed to Order",
    "loading": "Loading cart...",
    "error_loading": "Error loading cart",
    "items": "items",
    "checkout": "Checkout",
    "add_more_items": "Add more items",
    "item": "item",
    "continue_shopping": "Continue Shopping",
    "share_fallback_error": "Failed to share cart. Please try copying the link manually.",
    "share_failed_error": "Failed to share cart. Please try again.",
    "share_url_copied": "Cart link copied to clipboard!",
    "empty_title": "Your cart is empty",
    "empty_description": "Start adding delicious food to your cart to place an order.",
    "start_shopping": "Start Shopping",
    "share_modal_description": "Share this cart with friends and family so they can see what you're ordering.",
    "copy_link": "Copy Link",
    "close": "Close",
    "remove_cart_title": "Remove Cart",
    "remove_cart_message": "Are you sure you want to remove the cart from {{restaurantName}}? This action cannot be undone.",
    "remove_cart_confirm": "Remove Cart",
    "remove_cart_cancel": "Keep Cart",
    "removing_cart": "Removing..."
  },
  "myOrders": {
    "title": "My Orders",
    "loading": "Loading your orders...",
    "refresh": "Refresh",
    "no_orders": "No orders found",
    "order_number": "Order #",
    "status": "Status",
    "date": "Date",
    "total": "Total",
    "view_details": "View Details",
    "track_order": "Track Order",
    "show_filters": "Show Filters",
    "hide_filters": "Hide Filters",
    "all_statuses": "All Statuses",
    "from_date": "From Date",
    "to_date": "To Date",
    "apply": "Apply",
    "reset": "Reset",
    "unable_to_load": "Unable to load orders. Please try again.",
    "retry": "Retry",
    "no_orders_found": "No Orders Found",
    "no_orders_match_filters": "No orders match your current filters.",
    "clear_filters": "Clear Filters",
    "no_orders_yet": "You haven't placed any orders yet.",
    "ready_to_order": "Ready to order delicious food? Browse our restaurants and place your first order!",
    "browse_restaurants": "Browse Restaurants",
    "track": "Track",
    "cancel": "Cancel",
    "items": "Items",
    "subtotal": "Subtotal",
    "pickup_fee": "Pickup Fee",
    "delivery_fee": "Delivery Fee",
    "delivery_address": "Delivery Address",
    "name": "Name",
    "address": "Address",
    "phone": "Phone",
    "not_provided": "Not provided",
    "pickup_information": "Pickup Information",
    "pickup_location": "Pickup Location",
    "restaurant": "Restaurant",
    "pickup_instructions": "Please bring a valid ID and order confirmation",
    "restaurant_name": "Restaurant Name",
    "restaurant_address": "Restaurant Address",
    "address_not_available": "Address not available",
    "not_available": "Not available",
    "payment": "Payment",
    "payment_status": "Payment Status",
    "payment_method": "Payment Method",
    "online_payment": "Online Payment",
    "cash_on_delivery": "Cash on Delivery",
    "pending": "Pending",
    "track_order": "Track Order",
    "cancel_order": "Cancel Order",
    "delivery_confirmation": "Delivery Confirmation",
    "photo_taken_by_driver": "Photo taken by driver at delivery location",
    "cancel_order_title": "Cancel Order",
    "cancel_order_confirm": "Are you sure you want to cancel this order?",
    "cancellation_reason": "Reason for cancellation (optional):",
    "cancellation_placeholder": "Please provide a reason for cancelling this order...",
    "confirm_cancellation": "Confirm Cancellation",
    "keep_order": "Keep Order",
    "processing": "Processing..."
  },
  "placeOrder": {
    "invalid_order_details": "Invalid order details. Please start over.",
    "complete_order_first": "Please complete order details first",
    "cart_empty": "Your cart is empty",
    "afripay_not_available": "Afripay payment is not available",
    "failed_create_payment": "Failed to create payment session",
    "afripay_payment_failed": "Afripay payment failed",
    "error_processing_order": "Error processing your order",
    "server_not_responding": "Server not responding",
    "error_creating_order": "Error creating order",
    "order_placed_success": "Order placed successfully!",
    "failed_place_order": "Failed to place order",
    "validation_failed": "Validation failed",
    "sign_in_first": "To place an order, sign in first",
    "loading_order_details": "Loading order details...",
    "review_your_order": "Review Your Order",
    "review_order": "Review Your Order",
    "order_details": "Order Details",
    "delivery_order": "Delivery Order",
    "pickup_order": "Pickup Order",
    "items": "Items",
    "customer_information": "Customer Information",
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "delivery_information": "Delivery Information",
    "instructions": "Instructions",
    "edit_order_details": "Edit Order Details",
    "payment_method": "Payment Method",
    "cash_on_delivery": "Cash on Delivery / Pickup",
    "mobile_money_bank_card": "Afripay",
    "order_summary": "Order Summary",
    "subtotal": "Subtotal",
    "delivery_fee": "Delivery Fee",
    "pickup_fee": "Pickup Fee",
    "total": "Total",
    "processing": "Processing...",
    "place_order": "PLACE ORDER",
    "order_placed_successfully": "Order placed successfully!",
    "lumicash_payment": "Lumicash (Lumitel)",
    "coming_soon": "Coming Soon"
  },
  "payment": {
    "sign_in_to_complete": "Please sign in to complete payment",
    "no_order_information": "No order information found",
    "order_placed_success": "Order placed successfully!",
    "failed_place_order": "Failed to place order",
    "failed_create_afripay": "Failed to create Afripay payment",
    "processing_order": "Processing your order...",
    "loading": "Loading...",
    "complete_payment": "Complete Your Payment",
    "order_summary": "Order Summary",
    "subtotal": "Subtotal",
    "delivery_fee": "Delivery Fee",
    "total": "Total",
    "pay_with_afripay": "Pay with Afripay",
    "redirect_afripay": "You will be redirected to Afripay to complete your payment using:",
    "lumicash": "Lumicash",
    "ecocash": "Ecocash",
    "amount_to_pay": "Amount to pay",
    "pay_with_afripay_alt": "Pay with AfriPay",
    "secure_payment": "Your payment is processed securely by Afripay",
    "payment_not_supported": "Payment Method Not Supported",
    "select_valid_payment": "Please go back and select a valid payment method.",
    "go_back_to_cart": "Go Back to Cart"
  },
  "restaurant": {
    "restaurant_not_found": "Restaurant not found",
    "failed_to_load": "Failed to load restaurant",
    "hours_not_available": "Hours not available",
    "closed_today": "Closed today",
    "open": "Open",
    "closed": "Closed",
    "closing_soon": "Closing Soon",
    "link_copied": "Restaurant link copied to clipboard!",
    "login_to_rate": "Please log in to rate this restaurant",
    "loading_restaurant": "Loading restaurant...",
    "error": "Error",
    "hide_info": "Hide restaurant info",
    "show_info": "Show restaurant info",
    "hide_restaurant_info": "Hide restaurant info",
    "show_restaurant_info": "Show restaurant info",
    "hide_details": "Hide Details",
    "show_details": "Show Details",
    "hide": "Hide",
    "show": "Show",
    "share_restaurant": "Share restaurant",
    "share": "Share",
    "rate_restaurant": "Rate restaurant",
    "rate": "Rate",
    "search_menu": "Search {{name}}'s menu...",
    "cuisine": "Cuisine",
    "price": "Price",
    "rating": "Rating",
    "hours": "Hours",
    "phone": "Phone",
    "address": "Address"
  },
  "orderDetails": {
    "cart_empty": "Your cart is empty",
    "failed_calculate_delivery_fee": "Failed to calculate delivery fee",
    "failed_calculate_delivery": "Failed to calculate delivery fee",
    "location_outside_delivery_area": "The selected location is outside our delivery area. We currently only deliver within Bujumbura Mairie.",
    "outside_delivery_area": "The selected location is outside our delivery area. We currently only deliver within Bujumbura Mairie.",
    "delivery_info_saved": "Delivery information saved",
    "customer_info_saved": "Customer information saved",
    "failed_save_delivery_info": "Failed to save delivery information",
    "failed_save_customer_info": "Failed to save customer information",
    "failed_save_delivery": "Failed to save delivery information",
    "failed_save_customer": "Failed to save customer information",
    "first_name_required": "First name is required",
    "last_name_required": "Last name is required",
    "email_required": "Email is required",
    "phone_number_required": "Phone number is required",
    "phone_required": "Phone number is required",
    "street_required": "Street address is required",
    "quartier_required": "Quartier is required",
    "city_required": "City is required",
    "state_required": "State is required",
    "country_required": "Country is required",
    "please_select_delivery_location": "Please click on the map to select your exact delivery location",
    "click_map_select": "Please click on the map to select your exact delivery location",
    "please_save_delivery_info": "Please save your delivery information to continue",
    "save_delivery_info": "Please save your delivery information to continue",
    "fill_required_fields": "Please fill in all required fields",
    "order_details": "Order Details",
    "order_type": "Order Type",
    "delivery": "Delivery",
    "pickup": "Pickup",
    "customer_information": "Customer Information",
    "first_name": "First Name",
    "last_name": "Last Name",
    "email_address": "Email Address",
    "phone_number": "Phone Number",
    "delivery_information": "Delivery Information",
    "street_address": "Street Address",
    "quartier": "Quartier",
    "city": "City",
    "state": "State",
    "country": "Country",
    "zip_code_optional": "Zip Code (Optional)",
    "select_delivery_location": "Select Delivery Location",
    "hide_map": "Hide Map",
    "show_map": "Show Map",
    "location_confirmed": "Location confirmed",
    "delivery_instructions_optional": "Delivery Instructions (Optional)",
    "saving": "Saving...",
    "delivery_info_saved": "Delivery Info Saved",
    "save_delivery_info": "Save Delivery Information",
    "estimated_delivery_fee": "Estimated delivery fee",
    "order_summary": "Order Summary",
    "subtotal": "Subtotal",
    "delivery_fee": "Delivery Fee",
    "pickup_fee": "Pickup Fee",
    "calculating": "Calculating...",
    "total": "Total",
    "continue_to_payment": "Continue to Payment"
  },
  "resetPassword": {
    "invalid_or_expired_link": "Invalid or expired reset link",
    "failed_send_reset_email": "Failed to send reset email. Please try again.",
    "passwords_not_match": "Passwords do not match",
    "passwords_do_not_match": "Passwords do not match",
    "password_too_short": "Password must be at least 6 characters long",
    "password_min_length": "Password must be at least 6 characters long",
    "password_reset_success": "Password reset successfully! You can now login with your new password.",
    "password_reset_successfully": "Password reset successfully! You can now login with your new password.",
    "failed_reset_password": "Failed to reset password. Please try again.",
    "invalid_reset_link": "Invalid Reset Link",
    "link_invalid_expired": "The password reset link is invalid or has expired.",
    "back_to_home": "Back to Home",
    "reset_password": "Reset Password",
    "set_new_password": "Set New Password",
    "enter_email_send_link": "Enter your email address and we'll send you a link to reset your password.",
    "enter_email_instruction": "Enter your email address and we'll send you a link to reset your password.",
    "enter_new_password": "Enter your new password below.",
    "enter_new_password_instruction": "Enter your new password below.",
    "email_address": "Email Address",
    "enter_email": "Enter your email",
    "enter_your_email": "Enter your email",
    "sending": "Sending...",
    "send_reset_link": "Send Reset Link",
    "back_to_login": "Back to Login",
    "new_password": "New Password",
    "enter_new_password": "Enter new password",
    "confirm_new_password": "Confirm New Password",
    "confirm_new_password_placeholder": "Confirm new password",
    "resetting": "Resetting..."
  },
  "restaurantApply": {
    "file_too_large": "File is too large. Maximum file size is 5MB. File size: {{size}} MB",
    "location_required": "Please select your restaurant location on the map",
    "select_location_map": "Please select your restaurant location on the map. This is required for delivery services.",
    "location_outside_service": "Selected location is outside our service area.",
    "please_provide": "Please provide:",
    "business_license": "Business License",
    "business_license_expiry": "Business License Expiry",
    "menu_food_license": "Menu/Food License",
    "menu_food_license_expiry": "Menu/Food License Expiry",
    "insurance_certificate": "Insurance Certificate",
    "insurance_certificate_expiry": "Insurance Certificate Expiry",
    "application_submitted": "Application submitted successfully! We'll review your information and contact you soon.",
    "application_submitted_successfully": "Application submitted successfully! We'll review your information and contact you soon.",
    "problem_submitting": "There was a problem submitting your application. Please try again later.",
    "submission_problem": "There was a problem submitting your application. Please try again later.",
    "become_partner": "Become a Restaurant Partner",
    "join_network": "Join our network of restaurants and reach more customers with DASHBASKET!",
    "join_network_description": "Join our network of restaurants and reach more customers with DASHBASKET!",
    "restaurant_information": "Restaurant Information",
    "restaurant_name": "Restaurant Name*",
    "cuisine_type": "Cuisine Type*",
    "cuisine_type_placeholder": "e.g., Italian, Chinese, Mexican",
    "cuisine_example": "e.g., Italian, Chinese, Mexican",
    "restaurant_description": "Restaurant Description*",
    "description_placeholder": "Tell us about your restaurant",
    "tell_about_restaurant": "Tell us about your restaurant",
    "website_optional": "Website (if available)",
    "website_placeholder": "https://www.yourrestaurant.com",
    "website_example": "https://www.yourrestaurant.com",
    "has_delivery_service": "We have our own delivery service",
    "own_delivery": "We have our own delivery service",
    "contact_information": "Contact Information",
    "owner_manager_name": "Owner/Manager Name*",
    "email_address": "Email Address*",
    "phone_number": "Phone Number*",
    "phone_placeholder": "e.g., +257 79 123456 or 79123456",
    "phone_example": "e.g., +257 79 123456 or 79123456",
    "restaurant_location": "Restaurant Location",
    "address_street": "Address/Street*",
    "quartier": "Quartier*",
    "city": "City*",
    "country": "Country*",
    "zip_code": "Zip Code",
    "location_on_map": "Restaurant Location on Map*",
    "restaurant_location_map": "Restaurant Location on Map*",
    "required": "Required:",
    "pin_location_description": "Pin your exact restaurant location on the map. This is essential for delivery drivers to find your restaurant and for our delivery services.",
    "pin_exact_location": "Pin your exact restaurant location on the map. This is essential for delivery drivers to find your restaurant and for our delivery services.",
    "hide_map": "Hide Map",
    "select_location_on_map": "Select Location on Map *",
    "select_location_map": "Select Location on Map *",
    "location_selected": "Location selected on map",
    "please_select_location": "Please select your restaurant location on the map",
    "location_selection_required": "Location selection required",
    "required_documents": "Required Documents",
    "upload_required_documents": "Upload Required Documents*",
    "all_documents_required": "All 3 documents are required:",
    "all_3_documents": "All 3 documents are required:",
    "file_requirements": "Max file size: 5MB per file. Accepted formats: PDF, DOC, DOCX, JPG, PNG",
    "max_file_size": "Max file size: 5MB per file. Accepted formats: PDF, DOC, DOCX, JPG, PNG",
    "business_license_required": "1. Business License*",
    "expiration_date": "Expiration Date*",
    "menu_food_license_required": "2. Menu/Food License*",
    "insurance_certificate_required": "3. Insurance Certificate*",
    "all_documents_uploaded": "All required documents uploaded",
    "upload_all_documents": "Please upload all required documents",
    "additional_information": "Additional Information",
    "additional_info_placeholder": "Any other details you'd like to share",
    "other_details": "Any other details you'd like to share",
    "submitting": "Submitting...",
    "submit_application": "Submit Application"
  },
  "sharedCart": {
    "invalid_share_link": "Invalid share link",
    "cart_not_found": "Shared cart not found or has been removed",
    "cart_not_found_or_removed": "Shared cart not found or has been removed",
    "failed_load_cart": "Failed to load shared cart",
    "failed_to_load": "Failed to load shared cart",
    "failed_load_into_carts": "Failed to load shared cart into your carts",
    "failed_to_load_into_carts": "Failed to load shared cart into your carts",
    "loading_shared_cart": "Loading shared cart...",
    "unable_load_cart": "Unable to Load Shared Cart",
    "unable_to_load": "Unable to Load Shared Cart",
    "go_to_my_carts": "Go to My Carts",
    "go_home": "Go Home",
    "cart_not_found_title": "Shared Cart Not Found",
    "cart_removed_invalid": "This cart may have been removed or the link is invalid.",
    "cart_removed_or_invalid": "This cart may have been removed or the link is invalid.",
    "shared_cart": "Shared Cart",
    "shared_by": "Shared by",
    "items": "items",
    "items_in_cart": "Items in this cart:",
    "cart_empty": "This cart is empty",
    "cart_is_empty": "This cart is empty",
    "qty": "Qty:",
    "each": "each",
    "total": "Total:",
    "visit_restaurant": "Visit Restaurant",
    "loading": "Loading...",
    "add_to_my_carts": "Add to My Carts",
    "subtotal": "Subtotal:",
    "delivery_fee": "Delivery Fee:"
  },
  "verify": {
    "verifying_payment": "Verifying your payment...",
    "order_id_missing": "Order ID is missing from the URL. Please check the link and try again.",
    "authentication_required": "Authentication required. Please log in and try again.",
    "payment_cancelled": "Payment was cancelled. You can try placing the order again.",
    "payment_verified": "Payment verified successfully! Redirecting to your orders...",
    "payment_verified_successfully": "Payment verified successfully! Redirecting to your orders...",
    "payment_verification_failed": "Payment verification failed. Please contact support.",
    "payment_verification_failed_contact_support": "Payment verification failed. Please contact support if this persists.",
    "authentication_failed": "Authentication failed. Please log in again.",
    "order_not_found": "Order not found. Please check the order details.",
    "verification_failed_contact": "Payment verification failed. Please contact support if this persists.",
    "go_back_to_cart": "Go Back to Cart",
    "try_again": "Try Again",
    "view_my_orders": "View My Orders",
    "processing_payment": "Processing Payment",
    "processing_payment_please_wait": "Processing your payment. Please wait while we confirm your payment with the provider. This may take up to 2 minutes.",
    "complete_payment_on_phone": "Please check your phone and complete the mobile money payment to confirm your order. Waiting for payment confirmation...",
    "complete_payment_title": "Complete Payment on Your Phone",
    "payment_timeout": "Payment verification timed out. Please check your orders or contact support if payment was deducted.",
    "payment_successful": "Payment Successful!",
    "payment_failed": "Payment Failed",
    "payment_cancelled_title": "Payment Cancelled",
    "thank_you_order": "Thank you for your order! You will receive a confirmation email shortly.",
    "track_order_my_orders": "You can track your order status in the 'My Orders' section.",
    "contact_support_if_issues": "If you continue to experience issues, please contact our support team."
  },
  "driverApply": {
    "file_too_large": "File is too large. Maximum file size is 5MB. File size: {{size}} MB",
    "please_provide": "Please provide:",
    "drivers_license": "Driver's License",
    "drivers_license_expiry": "Driver's License Expiry",
    "vehicle_insurance": "Vehicle Insurance",
    "vehicle_insurance_expiry": "Vehicle Insurance Expiry",
    "vehicle_registration": "Vehicle Registration",
    "vehicle_registration_expiry": "Vehicle Registration Expiry",
    "application_submitted": "Application submitted successfully! We'll review your information and contact you soon.",
    "problem_submitting": "There was a problem submitting your application. Please try again later.",
    "become_driver": "Become a Delivery Driver",
    "join_team": "Join our team of delivery partners and earn money on your own schedule!",
    "personal_information": "Personal Information",
    "first_name": "First Name*",
    "last_name": "Last Name*",
    "email_address": "Email Address*",
    "phone_number": "Phone Number*",
    "phone_example": "e.g., +257 79 123456 or 79123456",
    "address_information": "Address Information",
    "street_address": "Street Address*",
    "quartier_zone": "Quartier/Zone*",
    "city": "City*",
    "country": "Country*",
    "postal_code": "Postal Code",
    "driver_information": "Driver Information",
    "drivers_license_number": "Driver's License Number*",
    "vehicle_type": "Vehicle Type*",
    "car": "Car",
    "motorcycle": "Motorcycle",
    "bicycle": "Bicycle",
    "scooter": "Scooter",
    "other": "Other",
    "vehicle_make": "Vehicle Make*",
    "vehicle_make_example": "e.g., Toyota, Honda",
    "vehicle_model": "Vehicle Model*",
    "vehicle_model_example": "e.g., Camry, Civic",
    "vehicle_year": "Vehicle Year*",
    "vehicle_year_example": "e.g., 2019",
    "availability_experience": "Availability & Experience",
    "availability": "Availability*",
    "full_time": "Full-time",
    "part_time": "Part-time",
    "weekends_only": "Weekends only",
    "evenings_only": "Evenings only",
    "flexible_hours": "Flexible hours",
    "preferred_delivery_areas": "Preferred Delivery Areas",
    "delivery_areas_example": "e.g., Downtown, West Side, South Area",
    "delivery_experience": "Delivery Experience*",
    "no_experience": "No prior experience",
    "less_than_1_year": "Less than 1 year",
    "1_2_years": "1-2 years",
    "3_5_years": "3-5 years",
    "5_plus_years": "5+ years",
    "additional_information": "Additional Information",
    "upload_required_documents": "Upload Required Documents*",
    "all_3_documents": "All 3 documents are required:",
    "max_file_size": "Max file size: 5MB per file. Accepted formats: PDF, DOC, DOCX, JPG, PNG",
    "drivers_license_required": "1. Driver's License*",
    "expiration_date": "Expiration Date*",
    "vehicle_insurance_required": "2. Vehicle Insurance Certificate*",
    "vehicle_registration_required": "3. Vehicle Registration Document*",
    "all_documents_uploaded": "All required documents uploaded",
    "upload_all_documents": "Please upload all required documents",
    "agree_background_check": "I agree to a background check*",
    "other_details": "Any other details you'd like to share",
    "submitting": "Submitting...",
    "submit_application": "Submit Application"
  },
  "orderTracking": {
    "order_tracking": "Order Tracking",
    "order_number": "Order #",
    "current_status": "Current Status",
    "estimated_delivery": "Estimated Delivery",
    "driver_information": "Driver Information",
    "your_delivery_driver": "Your Delivery Driver",
    "driver_assigned": "Driver assigned",
    "driver_not_assigned": "Driver information will appear once assigned",
    "call_driver": "Call Driver",
    "vehicle": "Vehicle",
    "live_tracking": "Live Tracking",
    "updating_route": "Updating route...",
    "estimated_arrival": "Estimated Arrival",
    "calculating": "Calculating...",
    "distance": "Distance",
    "via_fastest_route": "via fastest route",
    "traffic": "Traffic",
    "light_traffic": "Light traffic",
    "moderate_traffic": "Moderate traffic",
    "heavy_traffic": "Heavy traffic",
    "checking_traffic": "Checking traffic...",
    "loading_enhanced_map": "Loading enhanced map...",
    "live_tracking_with_route": "Live tracking with route visualization",
    "your_driver": "Your Driver",
    "delivery_location": "Delivery Location",
    "optimal_route": "Optimal Route",
    "last_location_update": "Last location update",
    "updates_every_30_seconds": "Updates every 30 seconds",
    "route_summary": "Route Summary",
    "duration": "Duration",
    "min_delay": "min delay",
    "pickup_information": "Pickup Information",
    "pickup_location": "Pickup Location",
    "pickup_instructions": "Pickup Instructions",
    "bring_valid_id": "Bring a valid ID",
    "show_order_confirmation": "Show order confirmation",
    "pay_at_pickup": "Pay at pickup (if cash on delivery)",
    "order_ready": "Your order is ready!",
    "come_to_restaurant": "Please come to the restaurant to pick up your order.",
    "order_picked_up": "Order picked up successfully!",
    "thank_you_service": "Thank you for using our service.",
    "status_updates": "Status Updates",
    "delivery_confirmation": "Delivery Confirmation",
    "refresh_tracking": "Refresh Tracking",
    "real_time_updates_active": "Real-time updates active",
    "real_time_updates_disconnected": "Real-time updates disconnected",
    "last_updated": "Last updated",
    "arriving_now": "Arriving now",
    "minute": "minute",
    "minutes": "minutes",
    "hour": "hour",
    "hours": "hours",
    "expected_shortly": "Expected shortly",
    "calculating_eta": "Calculating...",
    "meters": "m",
    "kilometers": "km"
  }
}; 